import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController ,ModalController} from 'ionic-angular';
import { ViewController } from 'ionic-angular';

//@IonicPage()
@Component({
  selector: 'page-parent-feedback',
  templateUrl: 'parent-feedback.html',
})
export class ParentFeedbackPage {

  FEnquiryId:any;
  ParentFeedbackData:any;
  shownGroup:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, public loadingCtrl: LoadingController, public toastCtrl: ToastController,public alertCtrl: AlertController,private modalCtrl: ModalController,public storage: Storage,public _app: App, public viewCtrl: ViewController) {
    this.platform.ready().then(() => {

      this.FEnquiryId = navParams.get('FEnquiryId');
      console.log(this.FEnquiryId);

      this.get_parent_feedback_by_params(this.FEnquiryId);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParentFeedbackPage');
  }

  get_parent_feedback_by_params(FEnquiryId){
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 5000);
    this.service.httpcall('web_service/get_parent_feedback_by_params?params[FEnquiryId]='+FEnquiryId).subscribe(data => {
      loading.dismiss();
      console.log(data);
      this.ParentFeedbackData = data;
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.get_parent_feedback_by_params(this.FEnquiryId);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  get_color(ans){
    if(ans=='Yes'){
      return 'green-color';
    }else if(ans=='No'){
      return 'red-color';
    }else if(ans=='May Be'){
      return 'yellow-color';
    }

  }

  get_management_color(ans){
    if(ans=='Yes'){
      return 'blue-color';
    }else if(ans=='No'){
      return 'brown-color';
    }else {
      return 'green-color1';
    }
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  };

  isGroupShown(group) {
    return this.shownGroup === group;
  };

  goBack(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/parent-feedback/parent-feedback.ts